export default __webpack_public_path__ + "static/media/pathname_model_zip.6c5c088c.gif";